import './NotFound.css';

export const NotFound = () => (
  <div className="body">
    <div className="not-found" data-color="primary">
      <h1>Oops!</h1>
      <p>Sorry, we couldn’t find that page.</p>
    </div>
  </div>
);
